import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section id="inicio" className="relative h-[100svh] min-h-[640px] bg-black text-white overflow-hidden">
      <img
        src="https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/d885f48bd596f9cac93a40cb128417c2.jpeg"
        alt="Residencia moderna con alberca, cascada y fachada iluminada al atardecer — AM Estudio San Luis Potosí"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/25 to-black/70"></div>

      <div className="absolute inset-5 md:inset-10 pointer-events-none">
        <span className="absolute top-0 left-0 w-14 h-14 md:w-20 md:h-20 border-t border-l border-white/40"></span>
        <span className="absolute top-0 right-0 w-14 h-14 md:w-20 md:h-20 border-t border-r border-white/40"></span>
        <span className="absolute bottom-0 left-0 w-14 h-14 md:w-20 md:h-20 border-b border-l border-white/40"></span>
        <span className="absolute bottom-0 right-0 w-14 h-14 md:w-20 md:h-20 border-b border-r border-white/40"></span>
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-5 md:px-10">
        <p className="overline text-white/70 reveal">Arquitectura · Diseño · Construcción</p>
        <h1 className="font-display font-medium tracking-tightest leading-[0.9] text-[clamp(3rem,13vw,11rem)] mt-5 reveal">
          AM ESTUDIO
        </h1>
        <p className="max-w-xl text-white/75 mt-7 text-base md:text-lg leading-relaxed reveal">
          Diseñamos espacios desde la idea hasta su ejecución, combinando
          funcionalidad, estética y representación arquitectónica.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center gap-4 reveal">
          <Link
            to="/proyectos"
            className="whitespace-nowrap inline-flex items-center justify-center px-8 py-4 text-xs font-medium uppercase tracking-[0.18em] bg-white text-black hover:bg-neutral-200 transition-colors"
          >
            Ver proyectos
          </Link>
          <a
            href="#contacto"
            className="whitespace-nowrap inline-flex items-center justify-center px-8 py-4 text-xs font-medium uppercase tracking-[0.18em] border border-white text-white hover:bg-white hover:text-black transition-colors"
          >
            Cotizar proyecto
          </a>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 overline text-white/50">
        <i className="ri-arrow-down-line"></i>
      </div>
    </section>
  );
}